import React from 'react';
import Sheet from 'react-modal-sheet';

const PrivacyPolicyModal = ({ isOpen, onClose, sendSpinner, customDetails }) => {
	return (
		<Sheet isOpen={isOpen} onClose={onClose}>
			<Sheet.Container>
				<Sheet.Header>
					<div style={{ textAlign: 'right' }}>
						<button
							className="closeModal"
							onClick={onClose}
							style={{
								background: 'none',
								border: 'none',
								fontSize: '18px',
								fontWeight: 'bold',
								cursor: 'pointer',
								padding: '10px',
							}}
						>
							X
						</button>
					</div>
				</Sheet.Header>
				<Sheet.Content>
					<div style={{ height: '70vh', width: '100%' }}>
						<iframe
							src="https://finvu.in/privacy"
							style={{
								width: '100%',
								height: '100%',
								border: 'none',
								borderRadius: '8px'
							}}
							title="Finvu Privacy Policy"
							loading="lazy"
							sandbox="allow-same-origin allow-scripts"
						/>
					</div>
				</Sheet.Content>
			</Sheet.Container>
			<Sheet.Backdrop />
		</Sheet>
	);
};

export default PrivacyPolicyModal; 